import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import PrimaryTextField from "../../components/PrimaryTextField";
import { useTranslation } from "react-i18next";
import PrimarySelectField from "../../components/PrimarySelectField";
import EditableUserAvatar from "../../components/EditableUserAvatar";
import CircularButton from "../../components/CircularButton";
import { useDispatch, useSelector } from "react-redux";
import { getUser, getUserAvatar, updateUser, uploadAvatar } from "../../api/user";
import { setSnackBarData, setUserSettings } from "../../redux/reducers/common";

const SettingsPage = () => {
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const languages = [
    { label: t('JAPANESE'), value: 'ja' },
    { label: t('ENGLISH'), value: 'en' },
    ];
    const userSettings = useSelector((state:any) => state.common.userSettings);
    const [data, setData] = useState(userSettings);
    const [avatarImage, setAvatar]:any = useState(null);
    const user = useSelector((state:any) => state.common.user);

    const manageUpdate = (updatedData:any, labelToupdate:any) => {
        const tempData = { ...data, [labelToupdate]: updatedData };
        setData(tempData);
    }

    const manageSaveClick = () => {
        updateUser(data).then(() => {
            getUser().then((res:any) => {
                dispatch(setUserSettings(res));
            })
            const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("USER_PROFILE_UPDATED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
        }).catch(() => {
            const warningData: any = {
            isOpen: true,
            severity: "error",
            message: t("ERROR_IN_UPDATING_USER_PROFILE"),
            };
            dispatch(setSnackBarData(warningData));
        })
    }

    const manageCancelClick = () => {
        setData(userSettings);
    }

    const onImageUpload = (imageUrl:any, avatar:any) => {
        setAvatar(imageUrl);
        uploadAvatar({ avatar })
        .then(() => {
            getUserAvatar({ userId: user?.id }).then((res:any) => {
                setAvatar(res);
            });
            const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("USER_AVATAR_UPDATED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
        }).catch(() => {
            setAvatar(avatarImage);
            const warningData: any = {
            isOpen: true,
            severity: "error",
            message: t("ERROR_IN_UPDATING_USER_AVATAR"),
            };
            dispatch(setSnackBarData(warningData));
        })
    }

    useEffect(() => {
        getUser().then((res:any) => {
            dispatch(setUserSettings(res));
            setData(res);
        });
        user && user?.id &&
        getUserAvatar({ userId: user?.id }).then((res:any) => {
            setAvatar(res);
        });
    }, [dispatch, user]);

    return (
        <React.Fragment>
            <Box className={'contentSpacing'} sx={{ height: '100%', overflowY: 'auto' }}>
                <Box sx={{ 
                    width: '700px',
                    mr: 'auto',
                    ml: 'auto',
                    mt: '50px'
                }}>
                    <EditableUserAvatar
                    label=""
                    image={avatarImage}
                    onChange={onImageUpload}
                    name={data?.displayName}
                    size={150}
                    />
                    <PrimaryTextField 
                    label={t("USERNAME")}
                    value={data?.userName}
                    onChange={(d:any) => {manageUpdate(d, 'userName')}}
                    placeholder="Enter your username"
                    />
                    <PrimaryTextField 
                    label={t("FIRST_NAME")}
                    value={data?.firstName}
                    onChange={(d:any) => {manageUpdate(d, 'firstName')}}
                    placeholder="Enter your first name"
                    />
                    <PrimaryTextField 
                    label={t("LAST_NAME")}
                    value={data?.lastName}
                    onChange={(d:any) => {manageUpdate(d, 'lastName')}}
                    placeholder="Enter your last name"
                    />
                    <PrimaryTextField 
                    label={t("EMAIL")}
                    value={data?.email}
                    onChange={(d:any) => {manageUpdate(d, 'email')}}
                    placeholder="Enter your email"
                    />
                    <PrimaryTextField 
                    label={t("PASSWORD")}
                    value={data?.password}
                    onChange={(d:any) => {manageUpdate(d, 'password')}}
                    placeholder="Enter your password"
                    type={'password'}
                    />
                    <PrimarySelectField
                    label={t("LANGUAGE")}
                    value={data?.languageCode}
                    onChange={(d:any) => {manageUpdate(d, 'languageCode')}}
                    options={languages}
                    valueKey="value"    // Use 'code' as the value
                    labelKey="label"   // Display 'title' in the dropdown
                    placeholder="Select your language"
                    />
                    <Box sx={{
                        display: 'grid',
                        justifyContent: 'end',
                        gridTemplateColumns: 'auto auto',
                        gridGap: '20px'
                    }}>
                        <CircularButton
                            label={t("CANCEL")}
                            manageClick={manageCancelClick}
                        />
                        <CircularButton
                            label={t("SAVE")}
                            manageClick={manageSaveClick}
                        />
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
};

export default SettingsPage;